import {
  requestMemberDetail,
  requestMemberList,
  requestMemberEventUpdate,
  requestMemberInfoUpdate,
  requestMEventList,
  requestMemberCorpUpdate,
  requestSessionMember,
  requestChangeMarketAgreeMember
} from "@/apis/member_api";

import { deleteTokenInLocalStorage } from "@/utils/oauth";

import { deleteAccessTokenInHeader } from "@/apis/common_api";

import store from "@/store";
import router from "@/router";

const state = {
  accessToken: localStorage.getItem("access_token"),
  member: {
    memberId: localStorage.getItem("memberId"),
    memberName: localStorage.getItem("memberName"),
    memberClass: localStorage.getItem("memberClass"),
    memberAttr: localStorage.getItem("memberAttr"),
    memberAddr: localStorage.getItem("memberAddr"),
    memberAddrX: localStorage.getItem("memberAddrX"),
    memberAddrY: localStorage.getItem("memberAddrY"),
    memberPhone: localStorage.getItem("memberPhone"),
    memberPlaceName: localStorage.getItem("memberPlaceName"),
    memberCorpCode: localStorage.getItem("memberCorpCode"),
    memberCorpName: localStorage.getItem("memberCorpName"),
    memberCorpMaster: localStorage.getItem("memberCorpMaster")
  },
  oauthRegMember: {
    memberId: "",
    memberPhone: "",
    memberName: "",
    memberEmail: "",
    memberType: ""
  },
  memberList: [],
  memberPage: null,
  memberPageTotal: 0,
  memberTotalElements: 0,
  memberDetail: {
    memberAttr: {}
  },
  eventMList: [],

  memberIdSearchList: [],
  obituaryDisplayType:
    localStorage.getItem("obituaryDisplayType") !== null &&
    localStorage.getItem("obituaryDisplayType") !== undefined
      ? localStorage.getItem("obituaryDisplayType")
      : "1"
};

const getters = {
  // isAuthenticated(state) {
  //   // return !!state.accessToken;
  //   return true;
  // },
  memberInfo(state) {
    return state.member;
  },
  getMemberDetail(state) {
    return state.memberDetail;
  },
  getMemberIdSearchList(state) {
    return state.memberIdSearchList;
  },
  getObituaryDisplayType(state) {
    return state.obituaryDisplayType;
  }
};

function resetToken(state) {
  deleteTokenInLocalStorage();
  deleteAccessTokenInHeader();
  state.accessToken = null;
}

const mutations = {
  OBITUARY_DISPLAY_TYPE(state, data) {
    localStorage.setItem("obituaryDisplayType", data);
    state.obituaryDisplayType = data + "";
  },
  LOGIN(state) {
    state.accessToken = localStorage.getItem("access_token");
    router.push("/");
    store.dispatch("REQUEST_OBITUARY_ALL_LIST");
  },
  LOGOUT(state) {
    resetToken(state);
    store.commit("REQUEST_OBITUARY_ALL_LIST_INIT");
  },
  LOGOUT_WITH_TOKEN_INVALIDE(state) {
    resetToken(state);
    if (router.currentRoute.name != "boards") {
      router.push("/");
    }
  },
  MEMBER_DETAIL(state, member) {
    state.member = member;
    const memberCopy = JSON.parse(JSON.stringify(member));
    state.member.memberAttr = memberCopy.memberAttr.codeId;

    if (
      memberCopy.memberCorpCode !== null &&
      memberCopy.memberCorpCode !== undefined
    ) {
      state.member.memberCorpCode = memberCopy.memberCorpCode.codeId;
      state.member.memberCorpName = memberCopy.memberCorpCode.codeName;
    }
  },
  MEMBER_CROP_UPDATE_FAIL(state) {
    state.member.memberCorpCode = localStorage.getItem("memberCorpCode");
    state.member.memberCorpName = localStorage.getItem("memberCorpName");
  },
  MEMBER_LIST(state, data) {
    state.memberList = data.resultMemberList;
    state.memberPage = data.page;
    state.memberPageTotal = data.pageTotal;
    state.memberTotalElements = data.totalElemtnts;
  },
  EVENT_M_LIST(state, data) {
    state.eventMList = data.eventMList;
  },
  MEMBER_DETAIL_INIT(state) {
    state.memberDetail = {
      memberAttr: {}
    };
    state.eventMList = [];
  },
  MEMBER_INIT(state) {
    state.memberList = [];
    state.memberPage = null;
    state.memberPageTotal = 0;
    state.memberTotalElements = 0;
  },
  MEMBER_SEARCH_ID(state, data) {
    state.memberIdSearchList = data.resultMemberList;
  },
  MEMBER_SEARCH_INIT(state) {
    state.memberIdSearchList = [];
  }
};

const actions = {
  async REQUEST_LOGOUT(context) {
    try {
      context.commit("START_LOADING");
      context.commit("LOGOUT");
      router.push("/login");
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      context.commit("OPEN_MODAL", {
        title: "로그아웃 실패",
        content: e.response.data.message,
        option1: "닫기"
      });
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },

  async MEMBER_DETAIL(context) {
    const getMember = await requestMemberDetail(context.state.member);
    setMemberInfoLocalStorage(getMember.data.resultMember);
    context.commit("MEMBER_DETAIL", getMember.data.resultMember);
  },
  async REQUEST_MEMBER_CORP_UPDATE(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestMemberCorpUpdate(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        setMemberInfoLocalStorage(response.data.resultMember);
        context.commit("MEMBER_DETAIL", response.data.resultMember);
      } else {
        alert(response.data.message);
        context.commit("MEMBER_CROP_UPDATE_FAIL");
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      context.commit("MEMBER_CROP_UPDATE_FAIL");
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },
  async REQUEST_MEMBER_LIST(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestMemberList(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        context.commit("MEMBER_LIST", response.data);
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },
  async REQUEST_MEMBER_EVENT_COMPONENT_UPDATE(context, parameter) {
    let result = {};
    try {
      context.commit("START_LOADING");
      const response = await requestMemberEventUpdate(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        result.data = true;
        result.message = response.data.message;
      } else {
        result.data = false;
        result.message = response.data.message;
      }
      context.commit("END_LOADING");
      return result;
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      result.data = false;
      result.message = "업데이트에 실패하였습니다. 확인 후 다시 이용해주세요.";
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
      return result;
    }
  },
  async REQUEST_MEMBER_INFO_UPDATE(context, parameter) {
    let result = {};
    try {
      context.commit("START_LOADING");
      const response = await requestMemberInfoUpdate(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        result.data = true;
        result.message = response.data.message;
      } else {
        result.data = false;
        result.message = response.data.message;
      }
      context.commit("END_LOADING");
      return result;
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      result.data = false;
      result.message = "업데이트에 실패하였습니다. 확인 후 다시 이용해주세요.";
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
      return result;
    }
  },
  async REQUEST_M_EVENT_LIST(context) {
    try {
      context.commit("START_LOADING");
      const response = await requestMEventList();
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        context.commit("EVENT_M_LIST", response.data);
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      context.commit("OPEN_MODAL", {
        title: "실패",
        content: "확인해주세요.",
        option1: "닫기"
      });
      alert(
        "네트워크 장애로 인해 서버와 연결이 좋지 않아 정상적인 수행에 실패하였습니다."
      );
    }
  },

  async REQUEST_SECESSION_MEMBER(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestSessionMember(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        context.commit("END_LOADING");
        alert("탈퇴가 완료되었습니다.");
        context.commit("LOGOUT");
        router.push("/login");
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      alert(e);
    }
  },
  async REQUEST_CHANGE_MARKET_AGREE_MEMBER(context, parameter) {
    try {
      context.commit("START_LOADING");
      const response = await requestChangeMarketAgreeMember(parameter);
      if (
        response.data != null &&
        response.data != undefined &&
        response.data.result === "success"
      ) {
        setMemberInfoLocalStorage(response.data.resultMember);
        context.commit("MEMBER_DETAIL", response.data.resultMember);
        context.commit("END_LOADING");
      } else {
        alert(response.data.message);
      }
      context.commit("END_LOADING");
    } catch (e) {
      if (e === "refresh") {
        return;
      }
      context.commit("END_LOADING");
      alert(e);
    }
  }
};

export default { mutations, state, actions, getters };
